
import React, { useEffect, useState } from 'react';
import {gql, useQuery} from "@apollo/client";
import {MultiSelect} from "primereact/multiselect";
import {Skeleton} from "primereact/skeleton";
import {Dropdown} from "primereact/dropdown";

const GET_ZONES = gql`
    query GetZones {
        allCommonGeolocTypezones {
            nodes {
                idMegatype
                nameTypezone
                typeZone
            }
        }
    }
`;

export const SelectZones = ({ single, name, id, label, value, disabled, onChange, ...props }) => {

    const { data } = useQuery(GET_ZONES);

    const [zones, setZones] = useState([]);

    const formatZones = (zones) => {
        const uniqueMegatypes = zones.reduce((acc, zone) => {
            if (!acc[zone.idMegatype]) {
                acc[zone.idMegatype] = {label: zone.idMegatype, items: []};
            }
            acc[zone.idMegatype].items.push({label: `${zone.typeZone} - ${zone.nameTypezone}`, value: zone.typeZone});
            return acc;
        }, {});

        return Object.values(uniqueMegatypes);
    }

    useEffect(() => {
        if (data) {
            const _zones = formatZones(data.allCommonGeolocTypezones.nodes);

            setZones(_zones);
        }
    }, [data]);

    const _onChange = (e) => {
        onChange(e.value);
    }

    if (!zones.length) {
        return <Skeleton width="100%" height={'44px'}></Skeleton>
    }

    if (single) {
        return <Dropdown
            id={id}
            name={name}
            value={value}
            options={zones}
            onChange={_onChange}
            placeholder="Sélectionner un zone"
            optionLabel="name"
            filter
            filterBy={"name, value"}
            disabled={disabled}
            className={"w-full"}
        />
    }

    return  (
        <MultiSelect id={id}
                     name={name}
                     value={value}
                     filter
                     className={"w-full"}
                     disabled={disabled}
                     display={"chip"}
                     optionGroupLabel={"label"}
                     optionGroupChildren={"items"}
                     options={zones}
                     onChange={_onChange}
                     placeholder={"Sélectionner un ou plusieurs zones"}
        />
    )

}
